// extracted by mini-css-extract-plugin
export var active = "_3c-7";
export var container = "_3c-0";
export var evenWidth = "_3c-4";
export var large = "_3c-5";
export var outlet = "_3c-8";
export var slide = "_3c-2";
export var small = "_3c-6";
export var tab = "_3c-3";
export var tabs = "_3c-1";